export default __webpack_public_path__ + "static/media/gallery08.21c7a694.jpg";